import { render, staticRenderFns } from "./add-or-edit-project-scene-agreement.vue?vue&type=template&id=dd6f6c94&scoped=true&"
import script from "./add-or-edit-project-scene-agreement.vue?vue&type=script&lang=js&"
export * from "./add-or-edit-project-scene-agreement.vue?vue&type=script&lang=js&"
import style0 from "./add-or-edit-project-scene-agreement.vue?vue&type=style&index=0&id=dd6f6c94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6f6c94",
  null
  
)

export default component.exports